import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF, GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";

// Components, atoms, molecules, organisms
import APRowExpand from "../../../components/atoms/APDataTable/TableFunctionalities/APRowExpand";

export const getClientManagementColumns = ((translate: (arg: string) => any) => {
    const nameColHeader: string = translate('clientmanagement.table.columnHeaders.name');
    const clientIdColHeader: string = translate('clientmanagement.table.columnHeaders.clientId');
    const clientReferenceIdColHeader: string = translate('clientmanagement.table.columnHeaders.clientReferenceId');
    const countryColHeader: string = translate('clientmanagement.table.columnHeaders.country');

    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: nameColHeader,
            minWidth: 300,
            flex: 1
        },
        {
            field: 'clientId',
            headerName: clientIdColHeader,
            minWidth: 200,
            flex: 1
        },
        {
            field: 'clientReferenceId',
            headerName: clientReferenceIdColHeader,
            minWidth: 200,
            flex: 1
        },
        {
            field: 'country',
            headerName: countryColHeader,
            minWidth: 100,
            flex: 1
        },
        {
            ...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
            renderCell: (props: GridRenderCellParams<any>) => { return APRowExpand(props) },
            minWidth: 100,
            align: 'right',
            flex: 1
        }
    ];

    return columns;
});